import { FC } from 'react';
import { ISectionPageTitle } from '@belong/contentful';
import { PageTitle, Section } from '@belong/ui-components';

const SectionPageTitle: FC<ISectionPageTitle> = ({ id, identifier, ...props }: ISectionPageTitle) => {
  return (
    <Section
      data-contentid={id}
      data-identifier={identifier}
      isFullWidth
      isPadded={false}
      data-testid="section-page-title"
    >
      <PageTitle {...props} />
    </Section>
  );
};

export default SectionPageTitle;
